import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import * as React from 'react';
import Header from '../../Header';
import { useTheme } from '@emotion/react';
import DashboardLayout from '../layout';
import { BiDownload } from 'react-icons/bi';
import { downloadFileFromUrl, openFileInNewTab } from '../../../utils';
import lookup_table from '../../../constants/lookup_table.json';
import { useParams } from 'react-router-dom';

function MetaGameVR({ style = {} }) {
  const { palette, ...theme } = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const RenderRiggedItem = ({ data, margin = false }) => {
    return (
      <Box sx={{ marginTop: margin ? (isMobile ? '20px' : '4vw') : '' }}>
        <Typography
          sx={{
            fontWeight: '700',
            fontFamily: 'var(--font-f_r)',
            fontSize: isMobile ? '16px' : '1.2vw',
            textAlign: 'start',
            width: '100%',
            marginLeft: isMobile ? '10px' : '16px',
            textTransform: 'capitalize',
            color: '#fff',
            [theme.breakpoints.down('lg')]: {
              fontSize: '16px',
            },
            [theme.breakpoints.down('sm')]: {
              fontSize: '14px',
            },
          }}
        >
          {data?.title}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
            alignItems: 'center',
            justifyContent: isMobile ? 'center' : 'flex-start',
          }}
        >
          {data.items.map((mod, index) => {
            return (
              <Box
                key={index}
                sx={{
                  cursor: 'pointer',
                  border: '1px solid #474747',
                  padding: isMobile ? '10px' : '15px',
                  height: isMobile ? '160px' : '20vh',
                  width: isMobile ? (isSmallScreen ? '85%' : '40%') : '13vw',
                  margin: isMobile ? '5px' : '10px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '15px',
                }}
              >
                <img
                  style={{
                    height: isMobile ? '60%' : '70%',
                    marginBottom: isMobile ? '10px' : '20px',
                    maxWidth: '100%',
                    objectFit: 'contain',
                  }}
                  src={mod.image}
                  alt={mod.name}
                />
                <Typography
                  onClick={() =>
                    mod?.file
                      ? mod?.type === 'render'
                        ? openFileInNewTab(mod?.file)
                        : downloadFileFromUrl(mod.file, 'mutant')
                      : alert('No File Available')
                  }
                  sx={{
                    fontWeight: '700',
                    fontFamily: 'var(--font-f_r)',
                    fontSize: isMobile ? '14px' : '1vw',
                    textAlign: 'end',
                    width: '100%',
                    alignItems: 'center',
                    textTransform: 'capitalize',
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    [theme.breakpoints.down('lg')]: {
                      fontSize: '16px',
                    },
                    [theme.breakpoints.down('sm')]: {
                      fontSize: '12px',
                    },
                  }}
                >
                  Download
                  <BiDownload
                    color={'#94E161'}
                    style={{
                      marginLeft: '10px',
                      marginBottom: isMobile ? '0' : '-5px',
                    }}
                    size={isMobile ? 20 : 25}
                  />
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    );
  };
  const RiggedModel = () => {
    const { id } = useParams();
    const [riggedData, setRiggedData] = React.useState({
      title: 'File format available :',
      items: [
        {
          name: 'FBX',
          image:
            'https://ishrostorage.blob.core.windows.net/container-3d/fbxFile.png',
          file: '',
          type: 'fbx',
        },
        {
          name: 'GLB',
          image:
            'https://ishrostorage.blob.core.windows.net/container-3d/glbFile.png',
          file: '',
          type: 'glb',
        },
        // {
        //   name: "vrm",
        //   image:
        //     "https://ishrostorage.blob.core.windows.net/container-3d/vrmlFile.png",
        // },
      ],
    });
    React.useEffect(() => {
      setRiggedData({
        ...riggedData,
        items: [
          {
            ...riggedData.items[0],
            file: lookup_table[id]?.fbxURL,
          },
          riggedData.items[1],
        ],
      });
    }, [id]);
    return (
      <Box sx={{ width: '100%', padding: isMobile ? 1 : 3 }}>
        <RenderRiggedItem data={riggedData} />
      </Box>
    );
  };

  const Renders = () => {
    const { id } = useParams();
    const [riggedData, setRiggedData] = React.useState({
      title: 'File format available :',
      items: [
        {
          name: '4k',
          image: 'https://storage.googleapis.com/3d-container/4k.png',
          file: '',
          type: 'render',
        },
      ],
    });
    React.useEffect(() => {
      setRiggedData({
        ...riggedData,
        items: [
          {
            ...riggedData.items[0],
            file: `https://storage.cloud.google.com/mutant-hounds/Renders/FB/${id}.jpg`,
          },
        ],
      });
    }, [id]);
    return (
      <Box sx={{ width: '100%', padding: isMobile ? 1 : 3 }}>
        <RenderRiggedItem data={riggedData} />
      </Box>
    );
  };

  const layoutOptions = [
    {
      name: 'Rigged Model',
      children: RiggedModel(),
    },
    {
      name: 'Renders',
      children: Renders(),
    },
  ];
  return (
    <DashboardLayout layoutOptions={layoutOptions} title={'Meta/Game/VR'} />
  );
}

export default MetaGameVR;
